/**
 * NDIS case note support item display (COS / Allied Health).
 * Non-STAND claim types are shown in parentheses on the support item label.
 */

const CLAIM_TYPE_DISPLAY_LABELS = {
  TRAVEL: "Travel",
  CANC: "CANC",
  REPW: "REPW",
  TRAN: "TRAN",
  NF2F: "NF2F",
  THLT: "THLT",
  IRSS: "IRSS",
};

export function getCaseNoteClaimTypeDisplayLabel(claimTypeValue) {
  const ct = String(claimTypeValue ?? "").trim().toUpperCase();
  if (!ct || ct === "STAND") return null;
  return CLAIM_TYPE_DISPLAY_LABELS[ct] ?? ct;
}

const stripLegacyClaimTypeSuffix = (name) =>
  String(name ?? "")
    .trim()
    .replace(/\sTRAVEL(\s·\s[\d.]+\s*km)?$/i, "")
    .replace(/\s\([^)]+\)\s*$/i, "")
    .trim();

export function formatCaseNoteSupportItemName(name, claimTypeValue) {
  const baseName = stripLegacyClaimTypeSuffix(name);
  if (!baseName) return "";
  const claimLabel = getCaseNoteClaimTypeDisplayLabel(claimTypeValue);
  if (!claimLabel) return baseName;
  const bracketSuffix = ` (${claimLabel})`;
  if (baseName.toLowerCase().endsWith(bracketSuffix.toLowerCase())) {
    return baseName;
  }
  return `${baseName}${bracketSuffix}`;
}

export function formatCaseNoteSupportItemFullLabel(
  number,
  name,
  claimTypeValue
) {
  const num = String(number ?? "").trim();
  const displayName = formatCaseNoteSupportItemName(name, claimTypeValue);
  if (num && displayName) return `${num} ${displayName}`;
  return displayName || num || "";
}

/** Invoice / NDIS list rows — support item name with claim type when present. */
export function getCaseNoteSupportItemDisplayName(item) {
  const name =
    item?.support_item_name ??
    item?.price_catalog?.support_item_name ??
    "";
  return formatCaseNoteSupportItemName(name, item?.claim_type);
}

/** Support item dropdown rows — label includes claim type when not STAND. */
export function mapCaseNoteSupportItemOptions(supportItems, claimTypeValue) {
  return (supportItems || []).map((item) => {
    const pc = item?.price_catalog;
    return {
      ...item,
      label: formatCaseNoteSupportItemFullLabel(
        pc?.support_item_number,
        pc?.support_item_name,
        claimTypeValue
      ),
    };
  });
}

export const CASE_NOTE_RATIO_OPTIONS = [
  { label: "Standard", value: "Standard" },
  { label: "1:2", value: "1:2" },
];

export function normalizeCaseNoteRatio(ratioValue) {
  return String(ratioValue ?? "").trim() === "1:2" ? "1:2" : "Standard";
}

export function applyCaseNoteRatioAmount(amount, ratioValue) {
  const numericAmount = Number(amount ?? 0);
  if (!Number.isFinite(numericAmount)) return 0;
  const ratio = normalizeCaseNoteRatio(ratioValue);
  if (ratio === "1:2") return Number((numericAmount / 2).toFixed(2));
  return Number(numericAmount.toFixed(2));
}
